import React from 'react';
import Marquee from './marquee';
import SingleProject from './singleProject';

const Projects = () => {
  return (
    <div className="projects">
      <div className="projects_container">
        <h1 className="projects_title">Projects</h1>
        <SingleProject
          projectName="NoQ"
          details="Built an online pre-order mobile web-app to solve queue waiting and fraudulent payment
          for college restaurants and students. Used local storage browser API for faster and persistent add to cart feature
           Its PWA, fast and light on your storage space.
           Its in beta phase."
          tools="Next.js, Firebase, Framer Motion, next-pwa, next-auth"
          flexDirection="row"
          imageURL="images/noq-screenshot.png"
          linkToProject="https://noq-one.vercel.app/"
        />
        <SingleProject
          projectName="Amazone Clone"
          details="An E-Commerce fullstack Amazone Clone . Features include adding or deleting a product from cart and a sign-up page using firebase
          login packed with a one tap location detector for easy delivery."
          tools="React, Firebase and Google's Jeo Location API"
          flexDirection="row-reverse"
          imageURL="images/amazone-clone.jpg"
          linkToProject="https://clone-f1172.web.app/"
        />
      </div>
    </div>
  );
};

export default Projects;
